module.exports = __webpack_public_path__ + "img/9b328db.jpg";